import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeedbackModalComponent } from '../feedback-modal/feedback-modal.component';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-feedback-button',
  standalone: true,
  imports: [CommonModule, ModalModule],
  templateUrl: './feedback-button.component.html',
  styleUrls: ['./feedback-button.component.scss']
})
export class FeedbackButtonComponent {
  private readonly modalService = inject(BsModalService);

  openFeedbackModal() {
    this.modalService.show(FeedbackModalComponent, {
      class: 'modal-dialog-centered',
      backdrop: 'static',
      keyboard: true
    });
  }
}

